import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useDeleteContactSummary } from '~/hooks/reactQuery/queries/useContactSummaryMutations';
import { useLocaleKeys } from '~/i18n';
import { ContactErrorResponse } from '~/infra/error-response/ContactErrorResponse';
import { errorTextsPath } from '~/infra/error-response/ErrorResponse';
import { contactFullName } from '../ContactsDashboardRow.utils';
import { GetDeleteContactModalTID, deleteContactModalTextsPath } from './DeleteContactModal.utils';
export const DeleteContactModal = (param)=>{
    let { contact, dismissModal, testId } = param;
    const { t } = useLocaleKeys(deleteContactModalTextsPath);
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { DeleteContactModalTestIds } = useMemo(()=>GetDeleteContactModalTID(testId), [
        testId
    ]);
    const { showSuccessToast } = useOverlayContext();
    const { deleteContactSummary } = useDeleteContactSummary();
    const [errorMessage, setErrorMessage] = useState(null);
    const confirmDelete = async ()=>{
        setErrorMessage(null);
        try {
            await deleteContactSummary({
                contactId: contact.contactId
            });
        } catch (error) {
            setErrorMessage(new ContactErrorResponse(error).deleteMessage(errorTexts));
            return;
        }
        showSuccessToast(t.contactDeleted(), DeleteContactModalTestIds.SuccessToast());
        dismissModal();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        openBottomSheetOnMobile: true,
        skin: "danger",
        title: t.title(),
        primaryButtonLabel: t.deleteButton(),
        secondaryButtonLabel: t.cancelButton(),
        testId: DeleteContactModalTestIds.Root(),
        textAlignCenter: false,
        primaryButtonTestId: DeleteContactModalTestIds.DeleteButton(),
        secondaryButtonTestId: DeleteContactModalTestIds.CancelButton(),
        bi: {
            primaryButton: {
                name: 'delete_contact_submit'
            },
            secondaryButton: {
                name: 'delete_contact_cancel'
            },
            closeButton: {
                name: 'delete_contact_close'
            }
        },
        onPrimaryButtonClick: confirmDelete,
        onSecondaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: DeleteContactModalTestIds.Warning(),
                    children: t.warning({
                        name: contactFullName(contact)
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: t.question()
                }),
                errorMessage != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "error",
                    testId: DeleteContactModalTestIds.DeleteError(),
                    children: errorMessage
                })
            ]
        })
    });
};
